export default __webpack_public_path__ + "static/report_content-a334b3ffc7562e4aba84fbb7fc565937.png";